export enum NotificationsChannel {
    WEB = 'WEB',
    EMAIL = 'EMAIL',
}

export interface Notification {
    id: string;
    _id: string;
    channel: 'WEB' | 'EMAIL';
    icon?: string;
    image?: string;
    title?: string;
    description?: string;
    time: string;
    link?: string;
    useRouter?: boolean;
    read: boolean;
    createdAt: Date;
}
